// extracted by mini-css-extract-plugin
export var activityContainer = "_h0-0";
export var typingIndicatorContainer = "_h0-1";
export var typingIndicatorDot = "_h0-2";
export var wave = "_h0-3";